import { useQuery } from '@tanstack/react-query';
import { api, GrRewardRuleResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseRewardRulesOptions {
  gameConfigId?: string;
}

interface UseRewardRulesReturn {
  rules: GrRewardRuleResponse[];
  total: number;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useRewardRules(options: UseRewardRulesOptions = {}): UseRewardRulesReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.rewardRules(),
    queryFn: () =>
      api.listGameRewardsRules({
        gameConfigId: options.gameConfigId || undefined,
      }),
  });

  return {
    rules: data?.rules ?? [],
    total: data?.total ?? 0,
    loading: isLoading,
    error: error instanceof Error ? error.message : isError ? 'Failed to load reward rules' : null,
    refresh: () => {
      refetch();
    },
  };
}
